import { AuthenticationProvider } from './../providers/authentication/authentication';
import { Injector } from '@angular/core';

export function canEnterIfAuthenticated(target) {
  target.prototype.ionViewCanEnter = function() {
    return this.injector.get(AuthenticationProvider).isAuthenticated();
  };
}



// WEBPACK FOOTER //
// ./src/decorators/index.ts